import { Outlet } from "react-router-dom";

function Services() {
  return <Outlet />;
}

export default Services;
